
namespace RecordShield.Wallet {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.responsive()
    export class CreditConfigDialog extends Serenity.EntityDialog<CreditConfigRow, any> {
        protected getFormKey() { return CreditConfigForm.formKey; }
        protected getIdProperty() { return CreditConfigRow.idProperty; }
        protected getLocalTextPrefix() { return CreditConfigRow.localTextPrefix; }
        protected getService() { return CreditConfigService.baseUrl; }

        protected form = new CreditConfigForm(this.idPrefix);

        protected updateInterface(): void {
            super.updateInterface();
            debugger;
            if (Authorization.hasPermission("Administration:Security") == false) {
                Serenity.EditorUtils.setReadonly(this.element.find('.editor'), true);
                this.deleteButton.hide();
                this.applyChangesButton.hide();
                this.saveAndCloseButton.hide();
            }
        }

    }
}